import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { styles } from './styles';
import Messenger from '../Messenger';

const MessagesList = ({
  messages,
  scrollToBottom,
  setValue,
  value,
}) => {
  MessagesList.propTypes = {
    messages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    scrollToBottom: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
  };

  const ref = useRef(null);

  useEffect(() => {
    if (messages && messages.length && ref.current) {
      const { scrollTop } = ref.current;
      if (scrollTop < 80) {
        scrollToBottom();
      }
    }
  }, [messages]);


  useEffect(() => {
    const handleWheel = (event) => {
      if (ref.current) {
        event.preventDefault();
        ref.current.scrollTop -= event.deltaY;
      }
    };

    if (ref.current) {
      const scrollContainer = ref.current;
      scrollContainer.addEventListener('wheel', handleWheel);

      return () => {
        scrollContainer.removeEventListener('wheel', handleWheel);
      };
    }
    return undefined;
  }, []);

  return (
    <div ref={ref} style={styles.messagesList}>
      <div id="anchor" />
      <div style={styles.list}>
        <Messenger
          messages={messages || []}
          value={value}
          setValue={setValue}
        />
      </div>
    </div>
  );
};

export default MessagesList;
